import Notify from 'quasar/src/plugins/Notify.js';;
import _ from 'lodash';

type NotifyPosition = 'bottom-right';

interface Config {
  message: string,
  timeout?: number,
  group?: boolean
  color?: string,
  actions?: object[],
}

export default function notify(config: Config|string, color?: string) {
  const message = _.isString(config) ? config : config.message;
  const resolvedColor = color || ((!_.isString(config) && config.color) ? config.color : 'positive');
  const icon = resolvedColor === 'positive' ? 'fa fa-check text-positive' : 'fa fa-times text-negative';
  return Notify.create(Object.assign({
    icon,
    badgeColor: resolvedColor,
    message,
    timeout: 3000,
    position: 'bottom-right' as NotifyPosition,
    color: 'white',
    textColor: 'black',
    classes: 'bg-white',
  }, config));
}
